// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.input-error__message {
  color: var(--ion-color-danger);
  font-size: 0.75rem;
  line-height: 1.2;
}`, "",{"version":3,"sources":["webpack://./src/app/components/input-error/input-error.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAGE;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;AAAJ","sourcesContent":[":host {\n  display: block;\n}\n\n.input-error {\n  &__message {\n    color: var(--ion-color-danger);\n    font-size: 0.75rem;\n    line-height: 1.2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
